/**
 *  Module for charts library
 */

import PieChartDirective from './directives/pieChart';

export default angular.module('edge.platform.charts', []).directive('gwPieChart', PieChartDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/charts/module.js
// module id = 1885
// module chunks = 0